import { useMemo } from 'react';
import {
  AssistantRuntimeProvider,
  AssistantModalPrimitive,
} from '@assistant-ui/react';
import {
  useChatRuntime,
  AssistantChatTransport,
} from '@assistant-ui/react-ai-sdk';
import AssistantIcon from '@mui/icons-material/Assistant';
import { Thread } from '../../components/assistant-ui/thread';
import { Fab } from '@mui/material';
import { CredentialManager } from '../../util/api-client';

let MCP_CHAT_URL = '';
if (process.env.REACT_APP_ENVIRONMENT === 'production')
  MCP_CHAT_URL = 'https://assistant.orderflowteam.com/api/chat';
if (process.env.REACT_APP_ENVIRONMENT === 'qa')
  MCP_CHAT_URL = 'https://assistant.qa.orderflowteam.com/api/chat';
if (process.env.REACT_APP_ENVIRONMENT === 'development')
  MCP_CHAT_URL = 'https://assistant.dev.orderflowteam.com/api/chat';
if (process.env.REACT_APP_ENVIRONMENT === 'local')
  MCP_CHAT_URL = 'http://localhost:3012/api/chat';

const AssitantUi = () => {
  const transport = useMemo(
    () =>
      new AssistantChatTransport({
        api: MCP_CHAT_URL,
        headers: {
          'user-id': CredentialManager.getUserId() || '',
          'team-id': CredentialManager.getTeamId() || '',
          'user-name': CredentialManager.getUserName() || '',
          'client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      }),
    [],
  );
  const runtime = useChatRuntime({
    transport,
  });

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      <div className="flex" style={{ height: '60vh', width: '40vw' }}>
        <Thread />
      </div>
    </AssistantRuntimeProvider>
  );
};

export default AssitantUi;

export const AssistantModal = () => {
  const transport = useMemo(
    () =>
      new AssistantChatTransport({
        api: MCP_CHAT_URL,
        headers: {
          'user-id': CredentialManager.getUserId() || '',
          'team-id': CredentialManager.getTeamId() || '',
          'user-name': CredentialManager.getUserName() || '',
          'client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      }),
    [],
  );
  const runtime = useChatRuntime({
    transport,
  });

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      <AssistantModalPrimitive.Root>
        <AssistantModalPrimitive.Anchor className="fixed right-8 bottom-8 size-11">
          <AssistantModalPrimitive.Trigger asChild>
            <Fab
              color="primary"
              sx={{
                position: 'fixed',
                bottom: 30,
                right: 40,
              }}
            >
              <AssistantIcon />
            </Fab>
          </AssistantModalPrimitive.Trigger>
        </AssistantModalPrimitive.Anchor>
        <AssistantModalPrimitive.Content
          sideOffset={16}
          className="h-[700px] w-[500px] rounded-xl border bg-popover shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out"
        >
          <Thread />
        </AssistantModalPrimitive.Content>
      </AssistantModalPrimitive.Root>
    </AssistantRuntimeProvider>
  );
};
